import { useState, useEffect } from 'react'
import { Switch } from '@headlessui/react'
import FormContainer from "../../../components/atoms/forms/formContainer";
import Axios from "../../../AxiosConfig";
import Loader from "../../../components/atoms/loader";
import { useStore } from "../../../store";
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const CompanyLeaveSettings = ({
    onboarding = false
}) => {
    const [enabled, setEnabled] = useState([false, true, true, true, true, true, false])
    const [numberOfLeaves, setNumberOfLeaves] = useState(0)
    const [timePeriod, setTimePeriod] = useState("weekly")
    const [loading, setLoading] = useState(false);
    const [startMonth, setStartMonth] = useState(1);
    const { layoutStore } = useStore();
    useEffect(() => {
        setLoading(true)
        Axios.post("/company/leave-settings/get", {}).then((res) => {
            const data = res.data;
            if (data.workingDays) {
                let workingDays = [];
                days.forEach((day, idx) => {
                    workingDays.push(data.workingDays.includes(day));
                });
                setEnabled(workingDays);
            }
            if (data.leaveSettings) {
                if (data.leaveSettings.days)
                    setNumberOfLeaves(data.leaveSettings.days);
                if (data.leaveSettings.timePeriod)
                    setTimePeriod(data.leaveSettings.timePeriod);
                    if (data.leaveSettings.timePeriod === "yearly"){
                        setStartMonth(data.leaveSettings.startMonth)
                    }
            }
            setLoading(false);


        })
    }, []);
    const submitChanges = () => {
        setLoading(true)
        // Check number of leaves and time period are valid
        if (!numberOfLeaves) {
            layoutStore.showToaster(`Number of leaves is required`, "error");
            setLoading(false);
            return
        }
        const leaveSettings = {
            days: numberOfLeaves,
            timePeriod: timePeriod
        }
        if (timePeriod === "yearly") {
            leaveSettings.startMonth = startMonth;
        }
        Axios.post("/company/leave-settings/update", {
            workingDays: enabled.map((day, idx) => day ? days[idx] : null).filter((day) => day),
            leaveSettings
        }).then((res) => {
            setLoading(false);
            layoutStore.showToaster(`Changes Saved`, "success");
            if (onboarding) {
                window.localStorage.setItem("showOnboarding", false);
                // reload the page
                window.location.reload(false);
            }
        })
    }
    return (
        <div>
            {loading && <Loader />}
            <FormContainer title="Working Days" description="Select the working days for your company. Employees won't be able to mark their attendance on non-working days">
                {days.map((day, dayIdx) => (
                    <Switch.Group as="div" className="flex inline items-center" key={dayIdx}>
                        <Switch
                            checked={enabled[dayIdx]}
                            onChange={() => {
                                const newEnabled = [...enabled]
                                newEnabled[dayIdx] = !newEnabled[dayIdx]
                                setEnabled(newEnabled)
                            }}
                            className={classNames(
                                enabled[dayIdx] ? 'bg-blue-600' : 'bg-gray-200',
                                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
                            )}
                        >
                            <span
                                aria-hidden="true"
                                className={classNames(
                                    enabled[dayIdx] ? 'translate-x-5' : 'translate-x-0',
                                    'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                )}
                            />
                        </Switch>
                        <Switch.Label as="span" className="ml-3">
                            <span className="text-sm font-medium text-gray-900">{day}</span>
                        </Switch.Label>
                    </Switch.Group>
                ))}
            </FormContainer>
            <FormContainer title="Available Leaves" description="Select Leave Tenure and Number Of Leaves Allocated/Tenure">
                <div>
                    <div className="flex justify-between">
                        <label htmlFor="numberOfLeaves" className="block text-sm font-medium text-gray-700">
                            Number of Leaves
                        </label>

                    </div>
                    <div className="mt-1">
                        <input
                            type="number"
                            name="numberOfLeaves"
                            placeholder="0.00"
                            onChange={(e) => {
                                setNumberOfLeaves(e.target.value)
                            }}
                            min={0}
                            value={numberOfLeaves}
                            className="block w-full rounded-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                </div>
                <div>
                    {
                        !loading &&
                        <>
                            <div>
                                <div className="flex justify-between">
                                    <label htmlFor="leaveTenure" className="block text-sm font-medium text-gray-700">
                                        Time Period
                                    </label>

                                </div>
                                <div className="mt-1">
                                    <select
                                        id="leaveTenure"
                                        name="leaveTenure"
                                        onChange={(e) => {
                                            setTimePeriod(e.target.value)
                                        }}
                                        className="mt-1 block w-full rounded-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                        required
                                        value={timePeriod}
                                    >
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="yearly">Yearly</option>                                        
                                    </select>
                                </div>
                            </div>
                            {timePeriod === "yearly" && (
                                <div className='mt-3'>
                                    <div className="flex justify-between">
                                        <label htmlFor="startMonth" className="block text-sm font-medium text-gray-700">
                                            Start Month For Leave Cycle
                                        </label>

                                    </div>
                                    <div className="mt-1">
                                        <select
                                            id="startMonth"
                                            name="startMonth"
                                            onChange={(e) => {
                                                setStartMonth(e.target.value)
                                            }}
                                            className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                            required
                                            value={startMonth}
                                        >
                                            <option value={1} >January</option>
                                            <option value={2} >February</option>
                                            <option value={3} >March</option>
                                            <option value={4} >April</option>
                                            <option value={5} >May</option>
                                            <option value={6} >June</option>
                                            <option value={7} >July</option>
                                            <option value={8} >August</option>
                                            <option value={9} >September</option>
                                            <option value={10} >October</option>
                                            <option value={11} >November</option>
                                            <option value={12} >December</option>
                                        </select>
                                    </div>
                                </div>
                            )}
                        </>
                    }
                </div>
            </FormContainer>
            <div className='text-right p-4'>
                <button
                    type="button"
                    onClick={submitChanges}
                    className="inline-flex ml-auto justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Update
                </button>
            </div>
        </div>
    );
}
export default CompanyLeaveSettings;